import React from "react";
import { PagamentoPixStyle, PagamentoProcessandoContentStyle } from "./style";
import { useState, useEffect } from "react";
import CheckoutTransparenteService from "../../services/CheckoutTransparenteService";
import { useSelector } from "react-redux";
import { moneyMask } from "../../utils/Masks";

export default function PagamentoPix({
  inserirCreditos = false,
  tipoPagamento: tipoPagamentoProp = "pix",
  fretesCarinho = [],
  onVoltar,
  somaValorTotalFretes,
  saldo = null,
  assinatura,
  onProcessar,
  uuidCarinho = null,
}) {
  const [pixCode, setPixCode] = useState("");
  const [pixQRCode, setQRPixCode] = useState("");
  const [copied, setCopied] = useState(false);
  const [paymentId, setPaymentId] = useState(null);
  const [sucesso, setSucesso] = useState(false);

  let { splitPayment } = useSelector((state) => {
    return {
      splitPayment: state.splitPayment,
    };
  });

  const handleCopy = () => {
    navigator.clipboard.writeText(pixCode);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  const tipoPagamento = splitPayment ? "carteira_flex+pix" : tipoPagamentoProp || "pix";

  useEffect(() => {
    handlePagamentoPix();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkoutTransparenteService = new CheckoutTransparenteService();

  const handlePagamentoPix = () => {
    checkoutTransparenteService.PagarComPix(
      uuidCarinho,
      somaValorTotalFretes,
      saldo,
      "BRL",
      assinatura,
      splitPayment,
      (err, data) => {
        if (err) {
          console.error("Erro ao pagar com Pix:", err);

          return;
        }

        console.log("Pix response:", data);
        setPixCode(data.pixCode);
        setQRPixCode(`data:image/png;base64,${data.qrCodeImage}`);
        setPaymentId(data.paymentId);
      }
    );
  };

  useEffect(() => {
    let intervalId;

    if (paymentId) {
      intervalId = setInterval(() => {
        checkoutTransparenteService.ObterStatusPix(paymentId, (err, data) => {
          if (err) {
            console.error("Erro ao consultar status Pix:", err);
            return;
          }

          console.log("Status Pix:", data);
          console.log("dados de pagamento", tipoPagamento);
          if (
            data.status === "APPROVED" ||
            data.status === "PAID" ||
            data.status === "Pagamento Confirmado"
          ) {
            clearInterval(intervalId);
            setSucesso(true);

            onProcessar?.({
              ...data,
              tipoPagamento,
            });
          }
        });
      }, 3000);
    }

    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentId]);

  return (
    <PagamentoProcessandoContentStyle>
      <PagamentoPixStyle>
        {sucesso ? (
          <div className="success-container">
            <div className="icon success">✓</div>
            <h2>O seu pagamento já foi confirmado!</h2>
            <button onClick={() => (window.location.href = "/envios")}>Meus Fretes</button>
          </div>
        ) : (
          <div>
            <div className="header">
              <div className="header-left">
                <span className="payment-icon">
                  {" "}
                  <img src="/pix.svg" alt="Pix" style={{ width: "24px", height: "24px" }} />
                </span>
                <span>Pix</span>
              </div>
              <span className="header-right">
                + {moneyMask((somaValorTotalFretes - saldo).toFixed(2).toString())}
              </span>
            </div>

            <div className="qrcode-box">
              {pixQRCode ? (
                <img src={pixQRCode} alt="QR Code Pix" className="qrcode-img" />
              ) : (
                <p>Nenhum QR Code gerado ainda</p>
              )}
            </div>

            <p className="info">
              Para concluir sua compra faça o pagamento Pix.
              <br />O pagamento será aprovado na mesma hora.
            </p>

            <p className="small-info">
              O código Pix tem validade de 20 minutos. Se você não conseguir realizar o pagamento
              dentro deste prazo, será necessário refazer sua compra.
            </p>

            <button
              type="button"
              className={`copy-btn ${copied ? "copied" : ""}`}
              onClick={handleCopy}
            >
              {copied ? "Código copiado!" : "COPIAR CÓDIGO"}
              {!copied && (
                <span>
                  <ion-icon name="copy-outline"></ion-icon>
                </span>
              )}
            </button>

            <button className="back-btn" onClick={onVoltar}>
              VOLTAR
            </button>
          </div>
        )}
      </PagamentoPixStyle>
    </PagamentoProcessandoContentStyle>
  );
}
